"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const GaugeProgress = _styledComponents.default.div`
	${({
  gaugeSize
}) => `
          position: relative;
          margin: 4px;
          float: left;
          text-align: center;
          width: ${gaugeSize}px;
          height: ${gaugeSize / 2}px;
`}
`;
var _default = exports.default = GaugeProgress;
module.exports = exports.default;
module.exports.default = exports.default;